import React from "react";

const AddIntegrationSkeleton: React.FC = () => {
    return (
        <div className="animate-pulse">
            {/* Header Skeleton */}
            <div className="mb-6">
                <div className="flex items-center gap-2 mb-1">
                    <div className="w-5 h-5 bg-gray-200 dark:bg-neutral-700 rounded" />
                    <div className="h-6 w-48 bg-gray-200 dark:bg-neutral-700 rounded" />
                </div>
                <div className="h-4 w-96 bg-gray-100 dark:bg-neutral-600 rounded" />
            </div>

            {/* Step Indicator & Actions Skeleton */}
            <div className="flex items-center justify-between mb-8">
                <div className="w-36 h-9 bg-gray-100 dark:bg-neutral-600 rounded-lg" />

                {/* Steps */}
                <div className="flex items-center gap-12">
                    <div className="flex items-center gap-3">
                        <div className="w-8 h-8 bg-gray-200 dark:bg-neutral-700 rounded-full" />
                        <div className="space-y-1">
                            <div className="h-4 w-20 bg-gray-200 dark:bg-neutral-700 rounded" />
                            <div className="h-3 w-24 bg-gray-100 dark:bg-neutral-600 rounded" />
                        </div>
                    </div>
                    <div className="w-12 h-[2px] bg-gray-100 dark:bg-neutral-600" />
                    <div className="flex items-center gap-3">
                        <div className="w-8 h-8 bg-gray-100 dark:bg-neutral-600 rounded-full" />
                        <div className="space-y-1">
                            <div className="h-4 w-24 bg-gray-100 dark:bg-neutral-600 rounded" />
                            <div className="h-3 w-24 bg-gray-50 dark:bg-neutral-800 rounded" />
                        </div>
                    </div>
                </div>

                <div className="w-40 h-10 bg-gray-200 dark:bg-neutral-700 rounded-lg" />
            </div>

            {/* Main Content Grid */}
            <div className="grid md:grid-cols-2 gap-4">
                {/* Spending Channels Column */}
                <div className="bg-white dark:bg-neutral-800 border border-gray-100 dark:border-neutral-700 rounded-2xl p-5 shadow-sm space-y-5">
                    <div className="flex items-center justify-between mb-2">
                        <div className="flex items-center gap-2">
                            <div className="p-1.5 rounded-lg bg-indigo-50 w-8 h-8" />
                            <div className="h-3 w-36 bg-gray-200 dark:bg-neutral-700 rounded tracking-widest uppercase" />
                        </div>
                        <div className="h-5 w-8 bg-indigo-50 rounded-full" />
                    </div>

                    <div className="space-y-4">
                        {[1, 2, 3].map((i) => (
                            <div key={i} className="p-5 rounded-2xl border border-gray-50 bg-gray-50 dark:bg-neutral-800/50">
                                <div className="flex items-center justify-between">
                                    <div className="flex items-center gap-4">
                                        <div className="w-12 h-12 bg-white dark:bg-neutral-800 rounded-xl shadow-sm border border-gray-100 dark:border-neutral-700 p-2" />
                                        <div className="space-y-2">
                                            <div className="h-4 w-32 bg-gray-200 dark:bg-neutral-700 rounded" />
                                            <div className="h-3 w-64 bg-gray-100 dark:bg-neutral-600 rounded" />
                                        </div>
                                    </div>
                                    <div className="h-8 w-24 bg-gray-200 dark:bg-neutral-700 rounded-lg shadow-sm" />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Revenue Sources Column */}
                <div className="bg-white dark:bg-neutral-800 border border-gray-100 dark:border-neutral-700 rounded-2xl p-5 shadow-sm space-y-5">
                    <div className="flex items-center justify-between mb-2">
                        <div className="flex items-center gap-2">
                            <div className="p-1.5 rounded-lg bg-emerald-50 w-8 h-8" />
                            <div className="h-3 w-36 bg-gray-200 dark:bg-neutral-700 rounded tracking-widest uppercase" />
                        </div>
                        <div className="h-5 w-8 bg-emerald-50 rounded-full" />
                    </div>

                    <div className="space-y-4">
                        {[1, 2, 3].map((i) => (
                            <div key={i} className="p-5 rounded-2xl border border-gray-50 bg-gray-50 dark:bg-neutral-800/50">
                                <div className="flex items-center justify-between">
                                    <div className="flex items-center gap-4">
                                        <div className="w-12 h-12 bg-white dark:bg-neutral-800 rounded-xl shadow-sm border border-gray-100 dark:border-neutral-700 p-2" />
                                        <div className="space-y-2">
                                            <div className="h-4 w-32 bg-gray-200 dark:bg-neutral-700 rounded" />
                                            <div className="h-3 w-64 bg-gray-100 dark:bg-neutral-600 rounded" />
                                        </div>
                                    </div>
                                    <div className="h-8 w-24 bg-gray-200 dark:bg-neutral-700 rounded-lg shadow-sm" />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddIntegrationSkeleton;
